import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { server } from "../../server";
import axios from "axios";
import { loadSeller } from "../../redux/actions/user";
import { toast } from "react-toastify";

const OPENING_HOURS_DAYS = [
  { key: "monday", label: "Monday" },
  { key: "tuesday", label: "Tuesday" },
  { key: "wednesday", label: "Wednesday" },
  { key: "thursday", label: "Thursday" },
  { key: "friday", label: "Friday" },
  { key: "saturday", label: "Saturday" },
  { key: "sunday", label: "Sunday" },
];

const createDefaultOpeningHours = () =>
  OPENING_HOURS_DAYS.reduce((hours, day) => {
    hours[day.key] = { open: "", close: "" };
    return hours;
  }, {});

const normalizeOpeningHours = (openingHours) => {
  const normalizedHours = createDefaultOpeningHours();

  if (Array.isArray(openingHours)) {
    openingHours.forEach((entry) => {
      const dayKey = String(entry?.day || "").toLowerCase();
      if (normalizedHours[dayKey]) {
        normalizedHours[dayKey] = {
          open: entry?.openTime || entry?.open || "",
          close: entry?.closeTime || entry?.close || "",
        };
      }
    });

    return normalizedHours;
  }

  if (openingHours && typeof openingHours === "object") {
    OPENING_HOURS_DAYS.forEach(({ key }) => {
      const dayHours = openingHours[key];
      if (dayHours) {
        normalizedHours[key] = {
          open: dayHours.openTime || dayHours.open || "",
          close: dayHours.closeTime || dayHours.close || "",
        };
      }
    });
  }

  return normalizedHours;
};

const serializeOpeningHours = (openingHours) =>
  OPENING_HOURS_DAYS.map(({ key, label }) => ({
    day: label,
    openTime: openingHours?.[key]?.open || "",
    closeTime: openingHours?.[key]?.close || "",
  }));

const ShopSettings = () => {
  const { seller } = useSelector((state) => state.seller);
  const [name, setName] = useState(seller && seller.name);
  const [description, setDescription] = useState(
    seller && seller.description ? seller.description : ""
  );
  const [address, setAddress] = useState(seller && seller.address);
  const [phoneNumber, setPhoneNumber] = useState(seller && seller.phoneNumber);
  const [zipCode, setZipcode] = useState(seller && seller.zipCode);
  const [openingHours, setOpeningHours] = useState(() => normalizeOpeningHours(seller?.openingHours));
  const dispatch = useDispatch();

  useEffect(() => {
    setOpeningHours(normalizeOpeningHours(seller?.openingHours));
  }, [seller?.openingHours]);


  const updateHandler = async (e) => {
    e.preventDefault();

    await axios
      .put(
        `${server}/shop/update-seller-info`,
        {
          name,
          address,
          zipCode,
          phoneNumber,
          description,
          openingHours: serializeOpeningHours(openingHours),
        },
        { withCredentials: true, headers: {
          "Content-Type": "application/json",
          'current-profile': sessionStorage.getItem('currentProfile') || 'defaultProfile',
        }}
      )
      .then((res) => {
        toast.success("Shop info updated successfully!");
        dispatch(loadSeller());
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  const handleOpeningHoursChange = (day, openOrClose, value) => {
    setOpeningHours((prev) => ({
      ...prev,
      [day]: { ...(prev[day] || { open: "", close: "" }), [openOrClose]: value },
    }));
  };

  return (
    <div className="shop-settings-component-container">
      <div className="shop-settings-component-content">
        <div className="profile-content-component-form-container">
          <div className="profile-content-component-form-row">
            <div className="profile-content-component-form-group">
              <label className="profile-content-component-form-label">Handle</label>
              <input
                type="text"
                className="profile-content-component-form-input"
                value={seller?.handle || ""}
                readOnly
              />
            </div>
            <div className="profile-content-component-form-group">
              <label className="profile-content-component-form-label">Unique ID</label>
              <input
                type="text"
                className="profile-content-component-form-input"
                value={seller?.uniqueId || ""}
                readOnly
              />
            </div>
          </div>
          {seller?.qrCodeUrl && (
            <div className="profile-content-component-form-row">
              <div className="profile-content-component-form-group">
                <label className="profile-content-component-form-label">QR Code</label>
                <img
                  src={seller.qrCodeUrl}
                  alt="Shop QR Code"
                  style={{ width: '200px', height: '200px' }}
                />
              </div>
            </div>
          )}
        </div>
        {/* shop info */}
        <form
          className="shop-settings-component-form"
          onSubmit={updateHandler}
        >
          <div className="shop-settings-component-form-group">
            <label>Shop Name</label>
            <input
              type="name"
              placeholder={`${seller?.name}`}
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="shop-settings-component-input"
              required
            />
          </div>
          <div className="shop-settings-component-form-group">
            <label>Shop description</label>
            <input
              type="name"
              placeholder={`${
                seller?.description
                  ? seller.description
                  : "Enter your shop description"
              }`}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="shop-settings-component-input"
            />
          </div>
          <div className="shop-settings-component-form-group">
            <label>Shop Address</label>
            <input
              type="name"
              placeholder={seller?.address}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              className="shop-settings-component-input"
              required
            />
          </div>

          <div className="shop-settings-component-form-group">
            <label>Shop Phone Number</label>
            <input
              type="number"
              placeholder={seller?.phoneNumber}
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className="shop-settings-component-input"
              required
            />
          </div>

          <div className="shop-settings-component-form-group">
            <label>Shop Zip Code</label>
            <input
              type="number"
              placeholder={seller?.zipCode}
              value={zipCode}
              onChange={(e) => setZipcode(e.target.value)}
              className="shop-settings-component-input"
              required
            />
          </div>

          <div className="shop-settings-component-opening-hours">
            <label>Opening Hours</label>
            {OPENING_HOURS_DAYS.map((day) => (
                <div
                  key={day.key}
                  className="shop-settings-component-opening-hours-item"
                >
                  <span>{day.label}</span>
                  <div className="shop-settings-component-opening-hours-inputs">
                    <input
                      type="time"
                      value={openingHours[day.key]?.open || ""}
                      onChange={(event) =>
                        handleOpeningHoursChange(day.key, "open", event.target.value)
                      }
                      className="shop-settings-component-opening-hours-input"
                    />
                    <span>to</span>
                    <input
                      type="time"
                      value={openingHours[day.key]?.close || ""}
                      onChange={(event) =>
                        handleOpeningHoursChange(day.key, "close", event.target.value)
                      }
                      className="shop-settings-component-opening-hours-input"
                    />
                  </div>
                </div>
              ))}
          </div>

          <div className="shop-settings-component-form-group">
            <input
              type="submit"
              value="Update Shop"
              className="shop-settings-component-submit-button"
              required
              readOnly
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ShopSettings;

